import React from 'react';

function Footer() {
  return (
    <>
      <div className='is-mobile is-flex is-flex-direction-row is-justify-content-space-between is-align-content-center'>
        <p className="m-0 p-0 is-size-7">Copyright © 2025 Nudgemail</p>
        <div className=''>
          <p className="m-0 p-0 is-size-7">
            <a href="/terms" className='mr-2'>Terms</a>
            <a href="/privacy" className='mr-2'>Privacy</a>
          </p>
        </div>
      </div>
    </>
  );
}

export default Footer;